export default __webpack_public_path__ + "static/media/Advanced Potion Making - Spells_06.e78bdb37.jpg";